import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M9 5a3 3 0 0 1 3 -3a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3a3 3 0 0 1 -3 -3l0 -5" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 10a7 7 0 0 0 14 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 21l8 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 17l0 4" })
	]
});
export { SvgMicrophone as ReactComponent };
